import React, { ReactElement } from "react";
import Dropdown from "react-bootstrap/Dropdown";

import styles from "./topbarmenu.module.scss";

interface IProps { 
    title: string;
}
  
const TopBarMenu : React.FC<IProps> = (props) => {

  return (
    <Dropdown.Menu className={styles.topbarMenu}>
      <Dropdown.Header className={styles.topbarMenuHeader}>
        <h5 className={styles.topbarMenuTitle}>
          {props.title}
        </h5>
      </Dropdown.Header>
      
      {props.children}
    </Dropdown.Menu>
  );
}; 

export default TopBarMenu;